module.exports = [{"key":"20","title":"进入中间表"},{"key":"21","title":"生成申请单"},{"key":"22","title":"物流核收"},{"key":"23","title":"物流分发"},{"key":"24","title":"物流拒签"},{"key":"25","title":"申请单签收"},{"key":"26","title":"申请单全部完成"},{"key":"27","title":"申请单报告生成"},{"key":"28","title":"报告回传完成"}]


//////////////////
// WEBPACK FOOTER
// ./static/specTracker/specTracker-lis.json
// module id = ehO4
// module chunks = 2